import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import {
  LoadUnitsAction,
  ProductUnitActionTypes,
  ResetUnitsAction,
  LoadAlternativeUnitsCompleteAction,
} from '../../actions/product-unit.actions';
import { RESET_BUILDER } from '../../../../actions/order-builder.actions';
import { ProductService, UnitsResponse } from '@cemex-core/cmx-api';
import { UnicEffectsAvailableEnum } from '@ordersnproducts/modules/shared/modules/dynamic-effects/deletable-effect-sources.constant';
import { EffectsRegistrationService } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effects-registration.service';

/**
 * Loads units ussing this.productService.getUnits()
 * In order to get the conversions from the units. At the moment only Mexico needs this
 *
 * Effect loadUnits will listen to the same action (ProductUnitActionTypes.LOAD_UNITS)
 * to keep the same flow in the app
 */
@Injectable()
export class AlternativeUnitsEffects {
  loadAlternativeUnits: Observable<LoadAlternativeUnitsCompleteAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductUnitActionTypes.LOAD_UNITS),
      filter(() => this.isEffectAvailable()),
      mergeMap((action: LoadUnitsAction) => {
        const payloadProductId = action.payload.productId;
        return this.productService.getUnits(payloadProductId).pipe(
          map((result: UnitsResponse) => {
            return new LoadAlternativeUnitsCompleteAction({
              [payloadProductId]: result.productUnitConversions,
            });
          }),
        );
      }),
    ),
  );

  unitsReset$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(RESET_BUILDER),
      filter(() => this.isEffectAvailable()),
      map(() => new ResetUnitsAction()),
    ),
  );

  /**
   * Identifies if the effect is available to be executed
   * @returns {boolean}
   */
  private isEffectAvailable(): boolean {
    return this.effectRegister.isEffectAvailable(UnicEffectsAvailableEnum.AlternativeUnitsEffects);
  }

  constructor(
    private actions$: Actions,
    private productService: ProductService,
    private effectRegister: EffectsRegistrationService,
  ) {}
}
